import t from "../../../../../../../../../i18n";

export const FAULT_STATUS_DESCRIPTIONS: Record<string, string> = {
  TO_BE_ANALYSED: t("project.dashboard.fault.status.to_analyse"),
  SUSPECTED: t("project.dashboard.fault.status.suspected"),
  CONFIRMED: t("project.dashboard.fault.status.confirmed"),
  REJECTED: t("project.dashboard.fault.status.false_detection"),
  LEGACY_REJECTED: t("project.dashboard.fault.status.false_detection"),
};

export const QUANTITY_VALUE_VALIDITY: Record<string, string> = {
  NO_VALIDATION: "",
  INVALID_AUTO: t("measures.chart.tooltip.description.invalid_auto"),
  INVALID_AUTO_CROSS_FILTER: t("measures.chart.tooltip.description.invalid_auto_cross_filter", ""),
  INVALID_MANUAL: t("measures.chart.tooltip.description.invalid_manual"),
  VALID_AUTO: t("measures.chart.tooltip.description.valid_auto"),
  VALID_MANUAL: t("measures.chart.tooltip.description.valid_manual"),
  VALID_PARTIAL_INPUTS: t("symptoms.chart.legend.valid_partial_inputs"),
  INVALID_INHERITED: t("measures.chart.tooltip.description.invalid_herited"),
};
